import { MouseEvent, useState } from 'react'
import { Help } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { Dropdown } from '@components/menu/dropdown'
import { getAcademyUrl } from '@global/api'
import * as css from './styles'

enum MenuLink {
  HELP = 'https://support.claravine.com/hc/en-us',
  BLOG = 'https://www.claravine.com/category/product-updates/?utm_source=claravineplatform&utm_medium=claravineapplication&utm_campaign=productupdates&xcmp=claravineapplication_03242022_VCA86UI',
  FEEDBACK = '?pendo=jX98JKHjH0Qnh2nZU-8dxC4JcDU',
  REFERRAL = 'https://www.claravine.com/friends/?utm_source=claravine&utm_medium=referral&utm_campaign=customerreferral&xcmp=referral_03242022_YDZQSZZ&utm_content=topbar',
  ACADEMY = '',
}

export interface MenuItemDetails {
  name: string
  link: MenuLink | string | null
  external: boolean
  addDivider: boolean
  handleItemClick?: () => void
}

const MENU_ITEMS: MenuItemDetails[] = [
  { name: 'Help Center', link: MenuLink.HELP, external: true, addDivider: false },
  { name: 'Product Blog', link: MenuLink.BLOG, external: true, addDivider: false },
  { name: 'Share Feedback', link: MenuLink.FEEDBACK, external: false, addDivider: false },
  {
    name: 'Claravine Academy',
    link: null,
    external: true,
    addDivider: false,
    handleItemClick: () => {
      void getAcademyUrl().then(url => window.open(url, '_blank'))
    },
  },
  { name: 'Referral Program', link: MenuLink.REFERRAL, external: true, addDivider: true },
]

export const ResourceMenu = () => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null)

  return (
    <Dropdown
      id="user-menu"
      icon={
        <IconButton size="small" onClick={handleClick} css={css.iconButton}>
          <Help />
        </IconButton>
      }
      anchorEl={menuAnchor}
      onClose={handleClose}
      onClick={handleClose}
      menuItems={MENU_ITEMS}
    />
  )

  function handleClick(event: MouseEvent<HTMLElement>): void {
    setMenuAnchor(event.currentTarget)
  }

  function handleClose(): void {
    setMenuAnchor(null)
  }
}
